// extracted by mini-css-extract-plugin
export var alignBaseline = "_i-9";
export var alignCenter = "_i-5";
export var alignFlexEnd = "_i-7";
export var alignFlexStart = "_i-6";
export var alignSelfBaseline = "_i-e";
export var alignSelfCenter = "_i-a";
export var alignSelfFlexEnd = "_i-c";
export var alignSelfFlexStart = "_i-b";
export var alignSelfStretch = "_i-d";
export var alignStretch = "_i-8";
export var column = "_i-2";
export var columnReverse = "_i-4";
export var flex = "_i-0";
export var justifyCenter = "_i-f";
export var justifyFlexEnd = "_i-h";
export var justifyFlexStart = "_i-g";
export var justifySpaceAround = "_i-j";
export var justifySpaceBetween = "_i-i";
export var justifySpaceEvenly = "_i-k";
export var row = "_i-1";
export var rowReverse = "_i-3";
export var wrapNowrap = "_i-m";
export var wrapWrap = "_i-l";
export var wrapWrapReverse = "_i-n";